'use client';

import { useEffect } from 'react';
import { useInactivityManager } from '@/lib/auth/useInactivityManager';
import { useAuthStore } from '@/stores/authStore';
import { HttpClient } from '@/api/HttpClient';

/**
 * Component that manages user inactivity tracking and automatic logout.
 * This component should be placed near the root of the application
 * to ensure inactivity tracking is always active when a user is logged in.
 * Tracks both API calls and user interactions (mouse, keyboard, etc.).
 */
export default function InactivityManager() {
  const { clearInteractionData, updateLastInteraction } = useInactivityManager();
  const { currentUser } = useAuthStore();

  useEffect(() => {
    HttpClient.setInactivityManager({ updateLastInteraction });
    return () => HttpClient.setInactivityManager(null);
  }, [updateLastInteraction]);

  // Clear interaction data on unmount if user is logged out
  useEffect(() => {
    if (!currentUser) {
      clearInteractionData();
    }
  }, [currentUser, clearInteractionData]);

  return null;
}
